export default __webpack_public_path__ + "static/media/closer-watt.bf3d707d.txt";